// Reglas del template de un ArrayField en el DynamicFormCreator.
// Spec: specs/features/ProtocolForms/arrayfield-creator.md

export const ARRAY_FIELD = 'ArrayField';
export const LABORATORY_RESULTS = 'LaboratoryResults';

// Controles que no se pueden agregar dentro del template (regla 2 de la spec).
export const TEMPLATE_RESTRICTED_FIELD_TYPES = [
    'ArrayField',
    'DividerField',
    'ProtocolFormField',
    'ProtocolImpFormField',
    'ProtocolConcomitantFormField',
    'PharmacyFormField',
    'FileUploadField',
];

// Valores de componentsType que se ofrecen al configurar un ArrayField: los que el PDF de la visita
// (DisplayTemplates/ArrayField.cshtml) renderiza como tabla. LaboratoryResults queda excluido: solo se
// crea desde el template de laboratorio (regla 8).
export const ARRAY_COMPONENTS_TYPES = ['', 'AdverseEvents', 'Drugs', 'Procedures', 'Anthropometrics', 'Vitals'];

export const isArrayFieldAllowed = (formType) => formType !== LABORATORY_RESULTS;

export const canAddToTemplate = (fieldType) => !TEMPLATE_RESTRICTED_FIELD_TYPES.includes(fieldType);

export const templateHasSyncTo = (template, syncTo) =>
    !!syncTo && (template ?? []).some(field => field.syncTo === syncTo);

export const getComponentsTypeLabelKey = (componentsType) =>
    `protocols.visit.formTemplate.componentsTypes.${componentsType || 'none'}`;

export const getSortedTemplate = (arrayField) =>
    [...(arrayField?.template ?? [])].sort((a, b) => a.order - b.order);

// El ArrayField necesita un id nuevo para ser destino si no tiene o si otro field raíz comparte el suyo.
export const needsNewArrayFieldId = (fields, arrayIndex) => {
    const id = fields[arrayIndex]?.id;
    return !id || fields.some((field, index) => index !== arrayIndex && field.id === id);
};

export const findArrayFieldsWithEmptyTemplate = (fields) =>
    (fields ?? []).filter(field => field._t === ARRAY_FIELD && (!field.template || field.template.length === 0));

const _renumber = (template) => template.map((field, index) => ({ ...field, order: index + 1 }));

const _withTemplate = (fields, arrayIndex, template) =>
    fields.map((field, index) => index === arrayIndex ? { ...field, template } : field);

// Agrega un field al final del template. Devuelve los fields nuevos y el índice del field agregado.
export const addFieldToTemplate = (fields, arrayIndex, templateField) => {
    const template = getSortedTemplate(fields[arrayIndex]);
    const newTemplate = _renumber([...template, templateField]);
    return {
        fields: _withTemplate(fields, arrayIndex, newTemplate),
        templateFieldIndex: newTemplate.length - 1,
    };
};

export const removeFieldFromTemplate = (fields, arrayIndex, templateFieldIndex) => {
    const template = getSortedTemplate(fields[arrayIndex]).filter((_field, index) => index !== templateFieldIndex);
    return _withTemplate(fields, arrayIndex, _renumber(template));
};

export const moveTemplateField = (fields, arrayIndex, oldIndex, newIndex) => {
    const template = getSortedTemplate(fields[arrayIndex]);
    if (newIndex < 0 || newIndex >= template.length || oldIndex === newIndex)
        return fields;

    const [moved] = template.splice(oldIndex, 1);
    template.splice(newIndex, 0, moved);
    return _withTemplate(fields, arrayIndex, _renumber(template));
};
